import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { contactInfo } from '../data/content';
import Modal from './Modal';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

function Footer() {
  const navigate = useNavigate();
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-grid">
          <div>
            <h3>Our Office</h3>
            <p>{contactInfo.address}</p>
            <p>{contactInfo.phone}</p>
            <p>{contactInfo.email}</p>
          </div>
          <div>
            <h3>Quick Links</h3>
            <ul>
              <li><button className="link-button" onClick={() => setIsTermsOpen(true)}>Terms of Service</button></li>
              <li><button className="link-button" onClick={() => setIsPrivacyOpen(true)}>Privacy policy</button></li>
              <li><button className="link-button" onClick={() => navigate("/contact")}>Help</button></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Goal Path HR Solution. All rights reserved.</p>
        </div>
      </footer>

      <Modal
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
        title="Privacy Policy"
      >
        <PrivacyPolicy />
      </Modal>

      <Modal
        isOpen={isTermsOpen}
        onClose={() => setIsTermsOpen(false)}
        title="Terms of Service"
      >
        <TermsOfService />
      </Modal>
    </>
  );
}

export default Footer;
